"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("../styles");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _designLanguage = require("@doordash/design-language");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ModalHeaderImage = function ModalHeaderImage(_ref) {
  var headerImage = _ref.headerImage,
      isFullScreenOnMobile = _ref.isFullScreenOnMobile;

  var theme = _react["default"].useContext(_designLanguage.ThemingContext);

  return /*#__PURE__*/_react["default"].createElement(_styles.HeaderImageWrapper, {
    isFullScreenOnMobile: isFullScreenOnMobile,
    modalBorderRadius: theme.BorderRadius.ModalDefault
  }, headerImage);
};

ModalHeaderImage.propTypes = {
  headerImage: _propTypes["default"].node,
  isFullScreenOnMobile: _propTypes["default"].bool
};
var _default = ModalHeaderImage;
exports["default"] = _default;